import ChatWithUsButton from "@/components/search-feedback/chatWithUsButton";
import Link from "next/link";
import styles from "./searchFeedbackWithChat.module.scss";

function SearchFeedbackWithChat() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.SearchFeedbackWithChat}>
        <p className={styles.heading}>Let&apos;s Help You Find What You Need</p>
        <p className={styles.bodyText}>
          Our team can help you search smarter, review available options, or confirm whether a product is available on
          Net32.
        </p>
        <ChatWithUsButton />
        <p className={styles.bodyText}>
          Chat is available from 8 AM to 8 PM ET. You can also contact <Link href="/contact-us">Customer Support</Link>{" "}
          anytime for help.
        </p>
      </div>
    </div>
  );
}

export default SearchFeedbackWithChat;
